/**
 *
 * Asynchronously loads the component for PriceConfigured
 *
 */

import { lazyLoad } from 'utils/loadable';

export const PriceConfigured = lazyLoad(
  () => import('./index'),
  module => module.PriceConfigured,
);
